import React from 'react';
import ChevronRightIcon from '@/assets/icons/chevron-right.svg';

export interface BookingTimeSlot {
  startTime: string;
  endTime: string;
  availableSlots?: number | 'unlimited';
  totalSlots?: number;
  href?: string;
}

export interface BookingEvent {
  date: string;
  // day: string;
  timeSlots: BookingTimeSlot[];
  eventTitle?: string;
}

export interface BookingCardProps {
  event: BookingEvent;
  onSlotClick?: (slot: BookingTimeSlot, event: BookingEvent) => void;
  className?: string;
  chevronSlot?: React.ReactNode;
}

export const CardSlot = ({
  event,
  onSlotClick,
  className,
  chevronSlot,
}: BookingCardProps) => {
  // const [month, day] = event.day.split(' ');
  const dateObj = new Date(event.date);
  const month = dateObj.toLocaleString('default', { month: 'short' }); // "Feb"
  const day = dateObj.getDate();
  return (
    <div className={`rounded-xl bg-brand-white p-5 mb-6 ${className ?? ''}`}>
      <div className="flex gap-5">
        {/* Date column */}
        <div className="w-12 flex-shrink-0 text-center">
          <div className="text-bodys font-bold text-brand-blue-3">{month}</div>
          <div className="font-title text-headingxxl font-bold text-brand-blue-3 leading-none">
            {day}
          </div>
        </div>

        {/* Time slots column */}
        <div className="flex flex-1 flex-col">
          {event.timeSlots.map((slot, index) => (
            <a
              key={index}
              // href={slot.href ?? '#'}
              onClick={
                onSlotClick
                  ? (e) => {
                      e.preventDefault();
                      onSlotClick(slot, event);
                    }
                  : undefined
              }
              className="flex items-center cursor-pointer justify-between border-neutral-grey-200 py-3 last:border-b-0 lg:hover:opacity-80 transition-opacity"
            >
              <div>
                <div className="text-bodym font-bold text-brand-blue-3">
                  {slot.startTime} — {slot.endTime}
                </div>
                {slot.availableSlots !== undefined && (
                  <div className="text-bodys text-text-default">
                    {'Available slots\u00A0\u2014\u00A0'}
                    {slot.availableSlots === 'unlimited' ? (
                      <span>unlimited</span>
                    ) : (
                      <>
                        <span className="font-bold">{slot.availableSlots}</span>
                        {slot.totalSlots !== undefined && (
                          <span className="text-text-light">
                            {` of ${slot.totalSlots}`}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
              <span className="ml-4 text-text-light text-headingm">
                <ChevronRightIcon />
              </span>
            </a>
          ))}

          {/* Event title */}
          {event.eventTitle && (
            <p className="mt-3 text-bodyl text-text-default">
              {event.eventTitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSlot;
